import { CalendarDay } from './calendar-day';

export class CalendarMonth extends CalendarDay {}
